import { TfaLogo } from './TfaLogo'

interface Props {
  /** Внешний диаметр монеты в пикселях. */
  size?: number
  /** Дополнительный CSS-стиль контейнера. */
  style?: React.CSSProperties
  className?: string
  /** Включить блик (по умолчанию выключен для маленьких размеров < 24px). */
  glow?: boolean
}

/**
 * Универсальная иконка TuCoin — монета с лого ТФА внутри.
 * Используется везде вместо `<Gem>` или текста «TuCoin».
 * Стиль монеты совпадает с большой версией на главной/в попапе TuCoinInfoSheet.
 */
export function TuCoinIcon({ size = 18, style, className, glow }: Props) {
  const showGlow = glow ?? size >= 24
  const innerSize = Math.max(8, Math.round(size * 0.78))
  return (
    <span
      aria-hidden
      className={className}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size, height: size,
        borderRadius: '50%',
        background:
          'radial-gradient(circle at 30% 25%, #FFE89A 0%, #FFC940 40%, #E08300 80%, #A85B00 100%)',
        boxShadow:
          `0 ${Math.max(1, Math.round(size * 0.08))}px ${Math.max(2, Math.round(size * 0.25))}px rgba(255,149,0,0.45),` +
          '0 0 0 1px rgba(255,236,170,0.95) inset,' +
          (size >= 18 ? '0 0 0 2px rgba(184,90,0,0.55) inset,' : '') +
          (size >= 24 ? '0 0 0 3px rgba(255,236,170,0.55) inset' : ''),
        flexShrink: 0,
        ...style,
      }}
    >
      {showGlow && (
        <span style={{
          position: 'absolute',
          top: Math.max(1, Math.round(size * 0.08)),
          left: Math.max(2, Math.round(size * 0.17)),
          width: Math.max(6, Math.round(size * 0.34)),
          height: Math.max(3, Math.round(size * 0.18)),
          borderRadius: '50%',
          background: 'radial-gradient(ellipse at center, rgba(255,255,255,0.65) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />
      )}
      <TfaLogo size={innerSize} style={{ position: 'relative', zIndex: 1 }} />
    </span>
  )
}
